(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  const ROOT_SELECTOR = ".futureblink-badge-banner";
  const CONTAINER_SELECTOR = ".tooltip-container";
  const TRIGGER_SELECTOR = ".futureblink-icon-hover-cls";
  const TOOLTIP_SELECTOR = ".custom-tooltip";

  function log(...args) {
    // console.log("[TOOLTIP]", ...args);
  }

  function closeAll(except = null) {
    document.querySelectorAll(`${ROOT_SELECTOR} ${TOOLTIP_SELECTOR}.active`).forEach(t => {
      if (t !== except) {
        t.classList.remove("active");
        // log("Zamknięto tooltip", t);
      }
    });
  }

  const ORPHANS = ["i", "z", "w", "o", "u", "a", "do", "na", "od"];

  function fixOrphans(text) {
    // zamień spację po "sierotce" na &nbsp;
    const regex = new RegExp("\\b(" + ORPHANS.join("|") + ") ", "gi");
    return text.replace(regex, "$1&nbsp;");
  }

  function applyWidowFix() {
    const tooltips = document.querySelectorAll(".custom-tooltip p");
    if (!tooltips.length) {
      console.warn("[TOOLTIP] brak akapitów w tooltipach");
      return;
    }
    tooltips.forEach(p => {
      if (p.innerHTML.trim() !== "") {
        const original = p.innerHTML;
        const fixed = fixOrphans(original);
        if (original !== fixed) {
          // console.log("[TOOLTIP] poprawiono:", original, "→", fixed);
          p.innerHTML = fixed;
        }
      }
    });
    // console.log("[TOOLTIP] ✅ Poprawiono sierotki w", tooltips.length, "akapitach");
  }

  function initTooltips() {
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) return false;

    const containers = root.querySelectorAll(CONTAINER_SELECTOR);
    if (containers.length === 0) return false;

    // log(`Znaleziono ${containers.length} tooltip-container`);

    const isTouch = window.matchMedia("(hover: none)").matches;

    containers.forEach((container, idx) => {
      const trigger = container.querySelector(TRIGGER_SELECTOR);
      const tooltip = container.querySelector(TOOLTIP_SELECTOR);
      if (!trigger || !tooltip) return;

      if (isTouch) {
        // 🔹 Mobile: klik
        trigger.addEventListener("click", (e) => {
          e.stopPropagation();
          const isActive = tooltip.classList.contains("active");
          closeAll();
          if (!isActive) {
            tooltip.classList.add("active");
            // log(`Kliknięto → otwarto tooltip #${idx + 1}`);
          } else {
            // log(`Kliknięto → zamknięto tooltip #${idx + 1}`);
          }
        });

        // zamknij tooltip klikając poza
        document.addEventListener("click", (e) => {
          if (!container.contains(e.target) && tooltip.classList.contains("active")) {
            tooltip.classList.remove("active");
            // log(`Klik poza → zamknięto tooltip #${idx + 1}`);
          }
        });

      } else {
        // 🔹 Desktop: hover
        let closeTimeout;
        container.addEventListener("mouseenter", () => {
          closeAll(tooltip);
          tooltip.classList.add("active");
          // log(`Hover in → tooltip #${idx + 1}`);
          if (closeTimeout) clearTimeout(closeTimeout);
        });

        container.addEventListener("mouseleave", () => {
          closeTimeout = setTimeout(() => {
            tooltip.classList.remove("active");
            // log(`Hover out → tooltip #${idx + 1}`);
          }, 120);
        });
      }
    });

    applyWidowFix();
    document.querySelectorAll('.custom-tooltip p:empty').forEach(el => el.remove());

    return true;
  }

  document.addEventListener("DOMContentLoaded", () => {
    const timer = setInterval(() => {
      if (initTooltips()) {
        clearInterval(timer);
        // log("Tooltips zainicjalizowane ✅");
      }
    }, 250);
  });
})();


  } catch(e) { console.error(e); }
})();
})();
